<template>
  <section>
    <WritingHeader />
    <WritingIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Writing',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.writing || {}
    }
  },
  mounted() {
    console.log('writing', this.$wp.pages.writing)
  }
}
</script>
